/**
 * API Configuration
 *
 * Centralizes logic for determining the API base URL, particularly for
 * supporting MSW (Mock Service Worker) in test environments.
 */

// NOTE: import.meta.env.MODE is set to 'test' by Vitest.
// We use this to switch to the absolute URL required by MSW in the jsdom environment.
export const IS_TEST = import.meta.env.MODE === 'test';

// In tests, we need an absolute URL for MSW interception (http://localhost:3000).
// In the browser, we use the current origin to ensure Hono's $url helper works correctly.
// In SSR/node (non-test), we fallback to empty string (relative).
export const API_ORIGIN = IS_TEST
  ? 'http://localhost:3000'
  : typeof window !== 'undefined'
    ? window.location.origin
    : '';

// Helper to construct full API URLs
export const getApiUrl = (path: string) =>
  `${API_ORIGIN}${path.startsWith('/') ? path : `/${path}`}`;
